import React, { useState, useEffect } from 'react';
import './App.css';
import MSAType2 from './components/MSAType2';

function App() {
  return (
    <div id="MSAType2" className="App Mobility">
      <MSAType2 />
    </div>
  );

  /*
  return (
    <div id="ProcessCapability">
      <h1>React App</h1>
      {jsonData && (
        <div>
          <h2>Data from Django:</h2>
          <pre>{JSON.stringify(jsonData, null, 2)}</pre>
        </div>
      )}
    </div>
  );
  */
}

export default App;
